import script from "./qrScanner.vue?vue&type=script&setup=true&lang=js"
export * from "./qrScanner.vue?vue&type=script&setup=true&lang=js"

import "./qrScanner.vue?vue&type=style&index=0&id=86ff96a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86ff96a4"]])

export default __exports__